/**
 * Resolves when zustand persist has rehydrated from browser storage.
 * Theme and session bootstrap must wait so a deep-link return does not
 * apply `theme.json` before the partner theme is available.
 */
export function waitForPersistHydration(persistApi: {
  hasHydrated: () => boolean;
  onFinishHydration: (fn: () => void) => void;
}): Promise<void> {
  if (persistApi.hasHydrated()) return Promise.resolve();
  return new Promise((resolve) => {
    persistApi.onFinishHydration(() => resolve());
  });
}
